var n = /* @__PURE__ */ ((t) => (t.ATTENTION = "attention", t.ACTION = "action", t.ACTION_FIXED = "action-fixed", t._INFORMATION = "information", t._HOVER_HELP = "hover-help", t))(n || {});
export {
  n as DIALOG_VARIANTS
};
//# sourceMappingURL=dialog-layout-variants.js.map
